import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import Spinner from 'react-spin';
import {Link, withRouter} from 'react-router';
import {MainContent, Page, PageBody} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class VerifyTokenForm extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    const {pushedRoute} = this.props;
    const {userId, token} = this.props.params;

    this.props.verifyToken(userId, token)
        .then(() => this.props.router.push(`/${pushedRoute}`));
  }

  render() {
    const {invalidToken} = this.props;

    return (
      <Page pageClassName="verify-token-page">
        <PageBody>
          <MainContent>
            <div>
              {!invalidToken && <h1>Verifying your request...<Spinner config={{left: '770px', top: '35px'}} /></h1>}
              {invalidToken && <h1>Sorry, but your link is either invalid or has expired. <Link to="/login">Click here</Link> to return to the login page.</h1>}
            </div>
          </MainContent>
        </PageBody>
      </Page>
    );
  }
}

VerifyTokenForm.propTypes = {
  invalidToken: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  verifyToken: PropTypes.func.isRequired,
  pushedRoute: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(
  mapStateToProps, {}
)(VerifyTokenForm));



// WEBPACK FOOTER //
// ./app/features/passwordManagement/components/VerifyTokenForm.js